const GENERIC_ERROR_MARK = 'CN_GEN_ERR';
/**
 * Базовый класс ошибки. Должен использоватья для создания типизированных ошибок.
 *
 * @export
 * @class GenericError
 * @extends {Error}
 */
class GenericError extends Error {
    static is(value) {
        if (typeof value !== 'object' || value === null) {
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return value['__mark'] === GENERIC_ERROR_MARK;
    }
    static isLike(value) {
        if (this.is(value)) {
            return true;
        }
        if (typeof value !== 'object' || value === null) {
            return false;
        }
        return value instanceof Error && 'type' in value && 'domain' in value;
    }
    static fromStructuredClone(err) {
        if (!this.is(err)) {
            return;
        }
        switch (err.type) {
            default: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { type, domain, details, message, stack, __mark, name, cause, ...custom } = err;
                const genErr = new GenericError({ type, message, details, domain });
                genErr.stack = stack;
                Object.assign(genErr, custom);
                return genErr;
            }
        }
    }
    _details = {};
    type;
    domain;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    __mark = GENERIC_ERROR_MARK;
    constructor({ message, type, domain, details }) {
        super(message, { cause: details });
        Object.setPrototypeOf(this, GenericError.prototype);
        this.type = type;
        this.domain = domain;
        this.name = type;
        if (details && !super.cause) {
            this._details = details;
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, GenericError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
    get details() {
        return super.cause || this._details;
    }
    /**
     * Печать детализации ошибки.
     * Внутри происходит сриализация details.
     *
     * @returns string детали ошибки в виде строки
     * @memberof GenericError
     */
    printDetails() {
        return JSON.stringify(this.details, null, 2);
    }
    toStructuredClone() {
        let details;
        if (this.details) {
            if (GenericError.is(this.details)) {
                details = this.details.toStructuredClone();
            }
            else {
                details = this.details;
            }
        }
        return {
            /** @private */
            __mark: GENERIC_ERROR_MARK,
            type: this.type,
            domain: this.domain,
            message: this.message,
            details,
            stack: this.stack,
            name: this.name,
        };
    }
    /**
     * Конвертация ошибки в данные.
     * Метод может быть полезен при пробрасывании информации от ошибок более низкого уровня в высокоуровневые ошибки
     */
    toJSON() {
        return {
            type: this.type,
            domain: this.domain,
            message: this.message,
            details: this.details,
        };
    }
}

export { GenericError };
//# sourceMappingURL=genericError.mjs.map
